import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";

export const useGroupId = (): string => {
  const { uuid } = useCurrentGroupContext();

  return uuid;
};
